var r=r=>{for(let t=1,e=r.length,a,o;t<e;t++){for(a=r[t],o=t;o>0&&r[o-1]>a;o--)r[o]=r[o-1];r[o]=a}return r};export{r as default};